// extracted by mini-css-extract-plugin
export default {"PopoverContent":"_PopoverContent--fP8m8","PopoverBody":"_PopoverBody--SsLEs","ExtraTags":"_ExtraTags--pmDYo"};